import React, { useState, useEffect } from 'react'

import { AxiosResponse } from 'axios'
import { Card, Row, Container } from 'components'
import { useLoading, useModal } from 'hooks'
import {
  CockpitServices,
  IAnalysisVersusPendencyResponse,
  ITotalAnalysisResponse,
  IPendencyResponseData
  //IAggregatedCockpitNgt2
} from 'services/NGT/Cockpit'
import { SPACING } from 'utils'

import { CardChart } from '../../../components'
import {
  PieChartCockpit2,
  LineChartCockpit2,
  StackedBarChartCockpit2
} from '../../../components/Charts'

const ManagerialCockpitNgt2: React.FC = () => {
  const { showModal } = useModal()
  const [analysisVersusPendency, setAnalysisVersusPendency] =
    useState<IAnalysisVersusPendencyResponse | null>(null)
  const [totalAnalysis, setTotalAnalysis] =
    useState<ITotalAnalysisResponse | null>(null)
  const [pendencyNotResolved, setPendencyNotResolved] =
    useState<IPendencyResponseData | null>(null)
  const [resolvedPendency, setResolvedPendency] =
    useState<IPendencyResponseData | null>(null)

  const { setLoading, setMsgErro } = useLoading()

  const getAnalysisVersusPEndency = () => {
    setLoading('loading')
    CockpitServices()
      .getAnalysisVersusPendency()
      .then(({ data }) => {
        setLoading('idle')

        setAnalysisVersusPendency(data)
      })
      .catch(() => {
        setLoading('error')
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao carregar análise Vs pendência',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
        // setMsgErro('Erro ao carregar análise Vs pendência')
      })
  }

  const getTotalAnalysis = () => {
    setLoading('loading')
    CockpitServices()
      .getTotalAnalysis()
      .then(({ data }) => {
        setLoading('idle')

        setTotalAnalysis(data)
      })
      .catch(() => {
        setLoading('error')
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao carregar análise total',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
        // setMsgErro('Erro ao carregar análise total')
      })
  }

  const getPendencies = () => {
    setLoading('loading')
    CockpitServices()
      .getPendencies()
      .then(({ data }) => {
        setLoading('idle')

        setPendencyNotResolved(data.pendenciaNaoResolvida)
        setResolvedPendency(data.pendenciaResolvida)
      })
      .catch(() => {
        setLoading('error')
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao carregar pendências',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
        // setMsgErro('Erro ao carregar pendências')
      })
  }

  useEffect(() => {
    getAnalysisVersusPEndency()
    getTotalAnalysis()
    getPendencies()
  }, [])

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
      borderRadius={`0px 10px 0px 0px`}
    >
      <Row justifyContent="center" gap={SPACING.spacing50}>
        <Container width="600px">
          <CardChart titleCard="Produtividade">
            <PieChartCockpit2
              values={analysisVersusPendency?.data}
              labels={analysisVersusPendency?.labels}
            />
          </CardChart>
        </Container>
        <Container width="600px">
          <StackedBarChartCockpit2
            data={totalAnalysis?.data}
            labels={totalAnalysis?.labels}
          />
        </Container>
      </Row>
      <Row
        alignItems="center"
        justifyContent="space-around"
        marginTop={SPACING.spacing50}
      >
        <Container width="800px">
          <LineChartCockpit2
            title="Evolução Valores Riscos – Pendência não resolvida"
            data={pendencyNotResolved?.data}
            labels={pendencyNotResolved?.labels}
          />
        </Container>

        <Container width="800px">
          <LineChartCockpit2
            title="Evolução Valores Riscos – Pendência resolvida"
            data={resolvedPendency?.data}
            labels={resolvedPendency?.labels}
          />
        </Container>
      </Row>
    </Card>
  )
}

export default ManagerialCockpitNgt2
